<template>
  <div>
    <section v-show="sidebarCurrentPanel === 'triggerbutton'" class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
      <div class="kp-modular-tab pt-page no-fade pt-page-current">
        <header class="kp-modular-title">
          {{ $t('edit.sidebar.call_button') }}
        </header>
        <div class="submenu-content sub-color">
          <header-config></header-config>
          <div class="submenu-padding">
            <options-config></options-config>
            <span v-if="boxConfig.trigger_button.kind === 'basic'">
              <background-color-config></background-color-config>
              <text-color-config></text-color-config>
              <align-config></align-config>
              <font-size-config></font-size-config>
              <border-radius-config></border-radius-config>
              <width-config></width-config>
              <height-config></height-config>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderConfig from './Header.vue';
import OptionsConfig from './options/Main.vue';
import BackgroundColorConfig from './BackgroundColor.vue';
import TextColorConfig from './TextColor.vue';
import FontSizeConfig from './FontSize.vue';
import BorderRadiusConfig from './BorderRadius.vue';
import WidthConfig from './Width.vue';
import HeightConfig from './Height.vue';
import AlignConfig from './Align.vue';

export default {
  components: {
    HeaderConfig,
    OptionsConfig,
    BackgroundColorConfig,
    TextColorConfig,
    FontSizeConfig,
    BorderRadiusConfig,
    WidthConfig,
    HeightConfig,
    AlignConfig,
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?614ff751
 **/